// Define a configuration object for different shipper types
export const shipperConfigurations = {
    postnl: {
        fields: [
            { name: 'apiKey', type: 'text', label: 'api_key' },
            { name: 'customerNumber', type: 'text', label: 'customer_number' },
            { name: 'customerCode', type: 'text', label: 'customer_code' },
            { name: 'mode', type: 'dropdown', label: 'mode', options: [
                { label: 'test', value: 'test' },
                { label: 'production', value: 'production' }
            ] }
        ],
        saveObject: {
            apiKey: "",
            customerNumber: "",
            customerCode: "",
            mode: ""
        },
        testConnection: true,
        requiredFields: ['apiKey', 'customerNumber', 'customerCode', 'mode'],
        validationRules: {
            apiKey: { required: true, minLength: 10 },
            customerNumber: { required: true, pattern: /^\d+$/ },
            customerCode: { required: true, minLength: 2 },
            mode: { required: true, options: ['test', 'production'] }
        },
        testingEndpoint: '/test-connection',
        connectionTimeout: 30000
    },
    dhl: {
        fields: [
            { name: 'key', type: 'text', label: 'key' },
            { name: 'userId', type: 'text', label: 'user_id' },
        ],
        saveObject: {
            key: "",
            userId: ""
        },
        testConnection: true,
        requiredFields: ['key', 'userId'],
        validationRules: {
            key: { required: true, minLength: 8 },
            userId: { required: true, minLength: 3 }
        },
        testingEndpoint: '/test-connection',
        connectionTimeout: 30000
    },
    parcel: {
        fields: [
            { name: 'username', type: 'text', label: 'username' },
            { name: 'password', type: 'text', label: 'password' },
            { name: 'mode', type: 'dropdown', label: 'mode', options: [
                { label: 'test', value: 'test' },
                { label: 'production', value: 'production' }
            ] }
        ],
        saveObject: {
            username: "",
            password: "",
            mode: ""
        },
        testConnection: true,
        requiredFields: ['username', 'password', 'mode'],
        validationRules: {
            username: { required: true, minLength: 3 },
            password: { required: true, minLength: 6 },
            mode: { required: true, options: ['test', 'production'] }
        },
        testingEndpoint: '/test-connection',
        connectionTimeout: 30000
    },
    cirro: {
        fields: [
            { name: 'clientId', type: 'text', label: 'client_id' },
            { name: 'secret', type: 'text', label: 'secret' },
            { name: 'mode', type: 'dropdown', label: 'mode', options: [
                { label: 'test', value: 'test' },
                { label: 'production', value: 'production' }
            ] }
        ],
        saveObject: {
            clientId: "",
            secret: "",
            mode: ""
        },
        testConnection: true,
        requiredFields: ['clientId', 'secret', 'mode'],
        validationRules: {
            clientId: { required: true, minLength: 8 },
            secret: { required: true, minLength: 8 },
            mode: { required: true, options: ['test', 'production'] }
        },
        testingEndpoint: '/test-connection',
        connectionTimeout: 30000
    },
    parcel2send: {
        fields: [
            { name: 'shipmentMethod', type: 'dropdown', label: 'shipment_method', options: [
                { label: 'Standaard', value: 'default' },
                { label: 'DPD Home', value: 'dpd_home' },
                { label: 'DPD Home Saturday delivery', value: 'dpd_home_saturday' }
            ] },
            { name: 'insuredAmount', type: 'text', label: 'insured_amount' },
            { name: 'length', type: 'text', label: 'length' },
            { name: 'width', type: 'text', label: 'width' },
            { name: 'height', type: 'text', label: 'height' }
        ],
        saveObject: {
            shipmentMethod: "",
            insuredAmount: "",
            length: "",
            width: "",
            height: ""
        },
        testConnection: true,
        requiredFields: ['shipmentMethod'],
        validationRules: {
            shipmentMethod: { required: true, options: ['default', 'dpd_home', 'dpd_home_saturday'] }
        },
        testingEndpoint: '/test-connection',
        connectionTimeout: 30000
    },
    sendcloud: {
        fields: [
            { name: 'publicKey', type: 'text', label: 'public_key' },
            { name: 'privateKey', type: 'text', label: 'private_key' }
        ],
        saveObject: {
            publicKey: "",
            privateKey: "",
        },
        testConnection: true,
        requiredFields: ['publicKey', 'privateKey'],
        validationRules: {
            publicKey: { required: true, minLength: 16 },
            privateKey: { required: true, minLength: 16 }
        },
        testingEndpoint: '/test-connection',
        connectionTimeout: 30000
    },
    ups: {
        fields: [
            { name: 'clientId', type: 'text', label: 'client_id' },
            { name: 'clientSecret', type: 'text', label: 'client_secret' },
            { name: 'accountNumber', type: 'text', label: 'account_number' },
            { name: 'environment', type: 'dropdown', label: 'environment', options: [
                { label: 'sandbox', value: 'sandbox' },
                { label: 'production', value: 'production' }
            ] },
            { name: 'negotiatedRates', type: 'boolean', label: 'negotiated_rates' },
           
        ],
        saveObject: {
            clientId: "",
            clientSecret: "",
            accountNumber: "",
            environment: "sandbox",
            negotiatedRates: false
        },
        testConnection: true,
        requiredFields: ['clientId', 'clientSecret', 'accountNumber', 'environment'],
        validationRules: {
            clientId: { required: true, minLength: 16 },
            clientSecret: { required: true, minLength: 8 },
            accountNumber: { required: true, pattern: /^[A-Z0-9]{6}$/ },
            environment: { required: true, options: ['sandbox', 'production'] }
        },
        testingEndpoint: '/test-connection',
        connectionTimeout: 30000
    },
    dpd: {
        fields: [
            { name: 'delis_id', type: 'text', label: 'delisId' },
            { name: 'password', type: 'text', label: 'password' },
        ],
        saveObject: {
            delis_id: "",
            password: ""
        },
        testConnection: true,
        requiredFields: ['delis_id', 'password'],
        validationRules: {
            delis_id: { required: true, minLength: 3 },
            password: { required: true, minLength: 3 }
        },
        testingEndpoint: '/test-connection',
        connectionTimeout: 30000
    },
    innosend: {
        fields: [
            { name: 'api_key', type: 'text', label: 'api_key' },
            { name: 'secret', type: 'text', label: 'secret' },
        ],
        saveObject: {
            api_key: "",
            secret: ""
        },
        testConnection: true,
        requiredFields: ['api_key', 'secret'],
        validationRules: {
            api_key: { required: true, minLength: 8 },
            secret: { required: true, minLength: 8 }
        },
        testingEndpoint: '/test-connection',
        connectionTimeout: 30000
    },
    innosendv2: {
        fields: [
            { name: 'api_token', type: 'text', label: 'api_token' },
        ],
        saveObject: {
            api_token: "",
            pickup_points_dhl: true,
            pickup_points_postnl: true
        },
        testConnection: true,
        requiredFields: ['api_token'],
        validationRules: {
            api_token: { required: true, minLength: 20 }
        },
        testingEndpoint: '/test-connection',
        connectionTimeout: 30000
    },
    zineps: {
        fields: [
            { name: 'client_id', type: 'text', label: 'client_id' },
            { name: 'client_secret', type: 'text', label: 'client_secret' },
        ],
        saveObject: {
            client_id: "",
            client_secret: ""
        },
        testConnection: true,
        requiredFields: ['client_id', 'client_secret'],
        validationRules: {
            client_id: { required: true, minLength: 8 },
            client_secret: { required: true, minLength: 8 }
        },
        testingEndpoint: '/test-connection',
        connectionTimeout: 30000
    },
    wegrow: {
        fields: [
            { name: 'apiKey', type: 'text', label: 'api_key' },
            {
                name: 'environment',
                type: 'dropdown',
                label: 'environment',
                options: [
                    { label: 'sandbox_test', value: 'sandbox' },
                    { label: 'production', value: 'production' }
                ],
                default: 'sandbox'
            },
            { name: 'senderName', type: 'text', label: 'wegrow_sender_name', tooltip: 'wegrow_sender_name_tooltip' },
        ],
        saveObject: {
            apiKey: "",
            environment: "sandbox",
            senderName: ""
        },
        testConnection: true,
        requiredFields: ['apiKey', 'environment'],
        validationRules: {
            apiKey: { required: true, minLength: 10 },
            environment: { required: true, options: ['sandbox', 'production'] },
            senderName: { required: false, maxLength: 35 }
        },
        testingEndpoint: '/test-connection',
        connectionTimeout: 30000
    },
    vinologix: {
        fields: [
            { name: 'accessToken', type: 'text', label: 'access_token' },
        ],
        saveObject: {
            accessToken: "",
            baseUrl: ""
        },
        testConnection: true,
        requiredFields: ['accessToken'],
        validationRules: {
            accessToken: { required: true, minLength: 20 }
        },
        testingEndpoint: '/test-connection',
        connectionTimeout: 30000
    },
    dhlgermany: {
        fields: [
            { 
                name: 'environment', 
                type: 'dropdown', 
                label: 'environment', 
                options: [
                    { label: 'sandbox_test', value: 'sandbox' },
                    { label: 'production', value: 'production' }
                ],
                default: 'sandbox'
            },
            // { 
            //     name: 'clientId', 
            //     type: 'text', 
            //     label: 'client_id',
            //     validation: 'required_alphanumeric',
            //     helpText: 'dhl_client_id_help'
            // },
            // { 
            //     name: 'clientSecret', 
            //     type: 'password', 
            //     label: 'client_secret',
            //     validation: 'required_min_8',
            //     helpText: 'dhl_client_secret_help'
            // },
            // { 
            //     name: 'subscriptionKey', 
            //     type: 'text', 
            //     label: 'subscription_key',
            //     validation: 'required_alphanumeric_hyphens',
            //     helpText: 'dhl_subscription_key_help'
            // },
            { 
                name: 'username', 
                type: 'text', 
                label: 'username'
            },
            { 
                name: 'password', 
                type: 'password', 
                label: 'password'
            },
            { 
                name: 'useAlternativeSender', 
                type: 'boolean', 
                label: 'use_alternative_sender_address',
                default: false,
                helpText: 'dhl_alternative_sender_help'
            },
            // Conditional fields for alternative sender address
            { 
                name: 'altSenderCompany', 
                type: 'text', 
                label: 'alt_sender_company',
                conditional: { field: 'useAlternativeSender', value: true },
                validation: 'required_when_alt_sender'
            },
            { 
                name: 'altSenderStreet', 
                type: 'text', 
                label: 'alt_sender_street',
                conditional: { field: 'useAlternativeSender', value: true },
                validation: 'required_when_alt_sender'
            },
            { 
                name: 'altSenderHouseNumber', 
                type: 'text', 
                label: 'alt_sender_house_number',
                conditional: { field: 'useAlternativeSender', value: true },
                validation: 'required_max_10',
                maxLength: 10
            },
            { 
                name: 'altSenderHouseNumberAddition', 
                type: 'text', 
                label: 'alt_sender_house_number_addition',
                conditional: { field: 'useAlternativeSender', value: true },
                maxLength: 10
            },
            { 
                name: 'altSenderPostalCode', 
                type: 'text', 
                label: 'alt_sender_postal_code',
                conditional: { field: 'useAlternativeSender', value: true },
                validation: 'postal_code'
            },
            { 
                name: 'altSenderCity', 
                type: 'text', 
                label: 'alt_sender_city',
                conditional: { field: 'useAlternativeSender', value: true },
                validation: 'required_when_alt_sender'
            },
            { 
                name: 'altSenderCountry', 
                type: 'dropdown', 
                label: 'alt_sender_country',
                conditional: { field: 'useAlternativeSender', value: true },
                options: [
                    { label: 'Germany', value: 'DE' },
                    { label: 'Austria', value: 'AT' },
                    { label: 'Switzerland', value: 'CH' }
                ],
                default: 'DE'
            }
        ],
        saveObject: {
            environment: "sandbox",
            username: "",
            password: "",
            useAlternativeSender: false,
            altSenderCompany: "",
            altSenderStreet: "",
            altSenderHouseNumber: "",
            altSenderHouseNumberAddition: "",
            altSenderPostalCode: "",
            altSenderCity: "",
            altSenderCountry: "DE"
        },
        testConnection: true // Enable test connection button (already implemented)
    },
    intrapost: {
        fields: [
            { name: 'apiKey', type: 'text', label: 'api_key' },
            { name: 'accountNumber', type: 'text', label: 'account_number' }
        ],
        saveObject: {
            apiKey: "",
            accountNumber: ""
        },
        testConnection: true,
        requiredFields: ['apiKey', 'accountNumber'],
        validationRules: {
            apiKey: { required: true, minLength: 8 },
            accountNumber: { required: true, minLength: 3 }
        },
        testingEndpoint: '/test-connection',
        connectionTimeout: 30000
    },
    myparcel: {
        fields: [
            { name: 'apiKey', type: 'text', label: 'api_key' },
        ],
        saveObject: {
            apiKey: ""
        },
        testConnection: true,
        requiredFields: ['apiKey', 'mode'],
        validationRules: {
            apiKey: { required: true, minLength: 8 }
        },
        testingEndpoint: '/test-connection',
        connectionTimeout: 30000
    },
    gls: {
        fields: [
            {
                name: 'username',
                type: 'text',
                label: 'gls_username'
            },
            {
                name: 'password',
                type: 'password',
                label: 'gls_password'
            },
            {
                name: 'customerNumber',
                type: 'text',
                label: 'gls_customer_number'
            },
            {
                name: 'contactId',
                type: 'text',
                label: 'gls_contact_id'
            },
             { 
                name: 'environment', 
                type: 'dropdown', 
                label: 'environment', 
                options: [
                    { label: 'sandbox_test', value: 'sandbox' },
                    { label: 'production', value: 'production' }
                ],
                default: 'production'
            },
        ],
        saveObject: {
            username: "",
            password: "",
            customerNumber: "",
            contactId: "",
            environment: ""
        },
        testConnection: true,
        requiredFields: ['username', 'password'],
        validationRules: {
            username: { required: true, minLength: 3 },
            password: { required: true, minLength: 6 },
            customerNumber: { pattern: /^\d*$/ },
            contactId: { minLength: 0 }
        },
        testingEndpoint: '/test-connection',
        connectionTimeout: 30000
    },
    trunkrs: {
    fields: [
        { name: 'apiKey', type: 'text', label: 'api_key' },
        { 
            name: 'environment', 
            type: 'dropdown', 
            label: 'environment', 
            options: [
                { label: 'sandbox_test', value: 'sandbox' },
                { label: 'production', value: 'production' }
            ],
            default: 'production'
        }
    ],
    saveObject: {
        apiKey: "",
        environment: "production"
    },
    testConnection: true,
    requiredFields: ['apiKey'],
    validationRules: {
        apiKey: { required: true, minLength: 8 }
    },
    testingEndpoint: '/test-connection',
    connectionTimeout: 30000
},
cycloon: {
    fields: [
        { name: 'apiKey', type: 'text', label: 'api_key' },
    ],
    saveObject: {
        apiKey: "",
        environment: "production"
    },
    testConnection: true,
    requiredFields: ['apiKey'],
    validationRules: {
        apiKey: { required: true, minLength: 8 }
    },
    testingEndpoint: '/test-connection',
    connectionTimeout: 30000
},
myparcelcom: {
    fields: [
        { name: 'clientId', type: 'text', label: 'client_id' },
        { name: 'secret', type: 'text', label: 'secret' },
    ],
    saveObject: {
        apiKey: "",
        apiSecret: ""
    },
    testConnection: true,
    requiredFields: ['apiKey', 'apiSecret'],
    validationRules: {
        apiKey: { required: true, minLength: 8 },
        apiSecret: { required: true, minLength: 8 }
    },
    testingEndpoint: '/test-connection',
    connectionTimeout: 30000
},
hst: {
    fields: [
        { name: 'login', type: 'text', label: 'login_name' },
        { name: 'password', type: 'password', label: 'password' },
        { name: 'customerId', type: 'text', label: 'customer_id'},
        { 
            name: 'environment', 
            type: 'dropdown', 
            label: 'environment', 
            options: [
                { label: 'sandbox', value: 'sandbox' },
                { label: 'production', value: 'production' }
            ],
            default: 'production'
        }
    ],
    saveObject: {
        login: "",
        password: "",
        customerId: ""
    },
    testConnection: true,
    requiredFields: ['login', 'password', 'customerId'],
    validationRules: {
        login: { required: true, minLength: 3 },
        password: { required: true, minLength: 5 }
    },
    testingEndpoint: '/test-connection',
    connectionTimeout: 30000
},
ampere: {
    fields: [
        { name: 'partnerId', type: 'text', label: 'partner_id' },
    ],
    saveObject: {
        apiKey: "",
        apiSecret: ""
    },
    testConnection: true,
    requiredFields: ['partnerId'],
    validationRules: {
        accessToken: { required: true, minLength: 8 },
        partnerId: { required: true, minLength: 1 }
    },
    testingEndpoint: '/test-connection',
    connectionTimeout: 30000
},
};